var map = {
	"./help_el-GR.md": [
		659,
		659
	],
	"./help_en-GB.md": [
		1513,
		513
	],
	"./help_fr-BE.md": [
		4308,
		308
	],
	"./help_ja-JP.md": [
		352,
		352
	],
	"./help_nl-BE.md": [
		3894,
		894
	],
	"./help_pt-BR.md": [
		8869,
		869
	],
	"./help_pt-PT.md": [
		8597,
		597
	],
	"./help_zh-TW.md": [
		1166,
		166
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 9084;
module.exports = webpackAsyncContext;